import { createTheme } from '@mui/material';
import { grey } from '@mui/material/colors';

export const theme = createTheme({
  palette: {
    primary: { main: '#38b6ff' },
    divider: grey[500],  // default: grey[300]
    background: {
      default: '#edf2f7',
      paper: '#ffffff',
    },
  },
});
